import { render, staticRenderFns } from "./ResultsBlock.vue?vue&type=template&id=8aa60424&scoped=true"
import script from "./ResultsBlock.vue?vue&type=script&lang=js"
export * from "./ResultsBlock.vue?vue&type=script&lang=js"
import style0 from "./ResultsBlock.vue?vue&type=style&index=0&id=8aa60424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa60424",
  null
  
)

export default component.exports